import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'
import withWidth, { WithWidth, isWidthDown } from '@material-ui/core/withWidth'

import Grid from '@material-ui/core/Grid'

import { IStoreProduct } from 'protos'

import StoreItem from 'components/StoreItem'

interface Props {
  className?: string
  products: IStoreProduct[]
}

const styles = createStyles({
  root: {
    overflow: 'hidden',
    overflowX: 'auto',
  },
})

type InjectedProps = Props & WithStyles<typeof styles> & WithWidth

const StoreItemList: React.SFC<InjectedProps> = ({ classes, className, width, products }) => {
  const wrap = isWidthDown('xs', width) ? 'nowrap' : 'wrap'

  return (
    <Grid
      className={classNames(className, classes.root)}
      spacing={4}
      wrap={wrap}
      zeroMinWidth
      container
    >
      {
        products.map((product) => (
          <Grid key={`product-${product.productId}`} item>
            <StoreItem {...product} />
          </Grid>
        ))
      }
    </Grid>
  )
}

export default withWidth()(withStyles(styles)(StoreItemList))
